module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [(_vm.$user.isAdminOrCoordinator && _vm.routeIsJobRequests) ? _c('button', {
    staticClass: "public",
    class: {
      'active': _vm.jobIsPublic
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleJobPublic
    }
  }, [_c('i', {
    staticClass: "fa fa-globe-asia"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [(_vm.job.user) ? _c('p', {
    staticClass: "rate"
  }, [_c('span', [_vm._v(_vm._s(_vm.job.user.profile.company_name))])]) : _vm._e(), _vm._v(" "), (_vm.job.commodity_and_location) ? _c('p', [_vm._v("\n          " + _vm._s(_vm.job.commodity_and_location_with_quantity) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Rate: " + _vm._s(_vm.job.rate || '–'))]), _vm._v(" "), _c('ul', {
    staticClass: "details"
  }, [_c('li', [_c('span', [_vm._v("Start Date:")]), _vm._v(" " + _vm._s(_vm.job.start_at || '–'))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("End Date:")]), _vm._v(" " + _vm._s(_vm.job.end_at || '–'))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Notes:")]), _vm._v(" "), (_vm.job.notes) ? [_vm._v("Yes")] : [_vm._v("No")]], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "btn-toolbar"
  }, [_c('a', {
    staticClass: "btn btn-info",
    attrs: {
      "data-toggle": "modal",
      "data-target": ".modal-job-request"
    },
    on: {
      "click": _vm.setActiveJob
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-map-marker-alt"
  })]), _vm._v(" "), _c('ladda-button', {
    ref: "decline",
    staticClass: "btn btn-danger",
    attrs: {
      "on-click": _vm.handleDeclineRequest
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-times"
  })]), _vm._v(" "), _c('ladda-button', {
    ref: "accept",
    staticClass: "btn btn-success",
    attrs: {
      "on-click": _vm.handleAcceptRequest
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-check"
  })])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-41d87d0c"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/JobRequestItem.vue
// module id = 978
// module chunks = 0